<template functional>
  <div class="progress-bar">
    <div class="progress-bar__wrapper">
      <div class="progress-bar__bar" :style="`width: ${props.value}%`"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
  },
}
</script>

<style lang="scss">
.progress-bar {
  background-color: transparent;
  border-radius: 0px;
  padding: 3px;
  width: 100%;
  &__wrapper {
    border-radius: 5px;
    padding: 3px;
    background-color: rgba(51, 51, 51, 0.96);
    text-align: center;
  }
  &__bar {
    background-color: var(--green);
    height: 5px;
    border-radius: 2px;
    position: relative;
    &::after {
      position: absolute;
      right: -13px;
      top: -5px;
      content: '';
      display: block;
      background-color: var(--green);
      height: 15px;
      width: 15px;
      border-radius: 100%;
      @include mobile {
        top: -11px;
        right: -26px;
        height: 26px;
        width: 26px;
      }
    }
  }
}
</style>
